import { render, staticRenderFns } from "./custom-element.vue?vue&type=template&id=1a5c7aa5&scoped=true&"
import script from "./custom-element.vue?vue&type=script&lang=js&"
export * from "./custom-element.vue?vue&type=script&lang=js&"
import style0 from "./custom-element.vue?vue&type=style&index=0&id=1a5c7aa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c7aa5",
  null
  
)

export default component.exports